import React from 'react';
import $ from 'jquery';
import { renderTableSunatGuide } from './renderTableSunatGuide';
import ApiClient from '../libs/apiClient';
let apiClient = ApiClient.getInstance();

const headersDataTableInit = [
    { title: "Autorización", value: true },
    { title: "Solicitud Original", value: true },
    // { title: "Serie", value: true },
    // { title: "Correlativo Actual", value: true },
    { title: "Guía", value: true }

];
class SunatGuideModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            headersDataTable: headersDataTableInit,
            openRows: null,
        };
    }
    componentDidMount = async () => {
        this.createDataTable();
    }
    createDataTable = () => {
        this.table = $('#dataTableGuide').DataTable({
            "dom": '<"toolbar">frtip',
            "pagingType": "full_numbers",
            "columnDefs": [{
                "targets": 0,
                "orderable": false
            }],
            responsive: true,
        });

        this.getTableInfoResult();
        this.changePaging();
    };
    changePaging = () => {
        let value = $('#changePaginateSelect').val();
        this.table.page.len(value).draw();
        this.getTableInfoResult();
    }

    getTableInfoResult = () => {

        let info = this.table.page.info();

        let num = 0;
        try {
            if (info && info.recordsDisplay !== 0) {
                num = 1;
            }
        } catch (error) {
            console.log(error)
        }

        $('#tableInfo').text((info.start + num) + " - " + info.end + " de " + info.recordsTotal);
        $('.dataTables_empty').text("No hay resultados por mostrar");
    };

    first = () => {
        this.table.page('first').draw('page');
        this.getTableInfoResult();


    }
    previous = () => {
        this.table.page('previous').draw('page');
        this.getTableInfoResult();
    }
    next = () => {
        this.table.page('next').draw('page');
        this.getTableInfoResult();
    }

    last = () => {
        this.table.page('last').draw('page');
        this.getTableInfoResult();

    }
    SearchInTable = key => {
        let value = key.target.value;
        let tabla = $('#dataTableGuide').DataTable();
        tabla.search(value);
        tabla.draw();
        this.getTableInfoResult();
    }
    onChangeOpenRow = (index) => {
        this.setState((prevState) => {
            const openRows = [...(prevState.openRows || [])]

            openRows[index] = !(openRows[index] ?? false)

            return { openRows }
        })
    }
    onChangeSCOP = (entryODRF, entryOWTQ, value) => {
        const { data, refreshSunatGuideData } = this.props;

        const newData = [...data];
        for (let index = 0; index < newData.length; index++) {
            const auth = newData[index];
            if (auth.DocEntryODRF === entryODRF) {
                for (let idxLines = 0; idxLines < auth.lines.length; idxLines++) {
                    const line = auth.lines[idxLines];
                    if (line.DocEntrySolicitud === entryOWTQ) {
                        line.U_FMB_SCOP_CODE = value
                    }

                }
            }
        }

        refreshSunatGuideData(newData);
    };

    ValidateScoopCode = async (entryODRF = null, entryOWTQ = null, U_FMB_SCOP_CODE = null) => {
        const { showAlert, enableSpinner, data } = this.props;
        // VALIDAR SI DEJAMOS ESTA CONDICIONAL MIENTRAS DEJO SOLO CON QUE NO VAYA VACIO
        // const regex = /^[PDECTO]\d{7}$/i;
        // if (!regex.test(newOrderModel.U_FMB_SCOP_CODE)) {
        //     showAlert({ type: 'error', timeOut: 5000, message: 'Insertar un codigo SCOP valido por favor' });
        //     return
        // }
        if (U_FMB_SCOP_CODE === '') {
            showAlert({ type: 'error', timeOut: 5000, message: 'Insertar un codigo SCOP valido por favor' });
            return
        }
        if (U_FMB_SCOP_CODE.length !== 11) {
            showAlert({ type: 'error', timeOut: 5000, message: 'El Código SCOP debe contener 11 dígitos' });
            return
        }
        //SEARCH FOR FINAL WHSCODE
        const auth = data.find(a => a.DocEntryODRF === entryODRF);
        const line = auth?.lines?.find(l => l.DocEntrySolicitud === entryOWTQ);
        const finalWhsCode = line?.ToWhsCodeFinal ?? null;

        const dataSearch = {
            scopCode: U_FMB_SCOP_CODE,
            whsCode: finalWhsCode,
            objType: '1250000001'
        }

        enableSpinner(true);
        const responseApi = await apiClient.ValidateScopCode(dataSearch);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? '' });
            return
        }

        if (!responseApi?.data?.FMB_ValidScoop) {
            showAlert({ type: 'error', timeOut: 5000, message: `Este codigo SCOP no es valido ` });
            showAlert({ type: 'info', timeOut: 5000, message: `Estatus: ${responseApi?.data?.estado ?? ''} ` });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: responseApi?.message ?? '' });

        const { refreshSunatGuideData } = this.props;
        const newData = [...data];
        for (let index = 0; index < newData.length; index++) {
            const auth = newData[index];
            if (auth.DocEntryODRF === entryODRF) {
                for (let idxLines = 0; idxLines < auth.lines.length; idxLines++) {
                    const line = auth.lines[idxLines];
                    if (line.DocEntrySolicitud === entryOWTQ) {
                        line.ValidSCOP = responseApi.data.FMB_ValidScoop ? responseApi.data.FMB_ValidScoop : false;
                    }
                }
            }
        }
        refreshSunatGuideData(newData)

        // copyOrderModel.ValidSCOP = responseApi.data.FMB_ValidScoop ? responseApi.data.FMB_ValidScoop : false;
        // copyOrderModel.U_LLG_ESTADO_SCOP = responseApi?.data?.estado ?? '';
        // copyOrderModel.U_LLG_PLACA_SCOP = responseApi?.data?.detalle?.camion?.placa ?? '';
        // copyOrderModel.U_LLG_CAPACIDAD_SCOP = responseApi?.data?.detalle?.camion?.capacidadKg ?? '';
        // copyOrderModel.U_LLG_FPEDIDO_SCOP = responseApi?.data?.fechaPedido ?? '';

    }
    render() {
        const { data, shadow, hideModal, forceProcess, continueCreate, view } = this.props;
        const { filter, headersDataTable, detailsData, listFilter, drivers, openRows } = this.state;
        const checkbox = {
            openRows: openRows,
            onChangeOpenRow: this.onChangeOpenRow,
            onChangeSCOP: this.onChangeSCOP,
            view,
            ValidateScoopCode: this.ValidateScoopCode
        }
        return (
            <div
                className="modal fade"
                id="sunatGuideModal"
                tabIndex="-1"
                role="dialog"
                aria-hidden="true"
                data-backdrop="static"
            >
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div
                        className="modal-content"
                        style={shadow
                            ? { boxShadow: "rgb(1 1 1 / 30%) 1px 1px 10px" }
                            : { boxShadow: "none" }
                        }
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Datos para Guía
                            </h5>
                            {/* <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                            >
                                <span>&times;</span>
                            </button> */}
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                {/* <FactoryActions
                                    
                                /> */}
                            </div>
                            <div className="form-group mb-2">
                                <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2' style={{ display: 'inline-flex' }} placeholder="Buscar en tabla" autoComplete="off" id='searchDataTableGuide'
                                    type='search' aria-controls='dataTableGuide' onChange={this.SearchInTable} />
                            </div>
                            <div className="w-100 table-scroll" style={{ maxHeight: '300px', minHeight: '300px', overflowY: 'auto' }}>
                                {renderTableSunatGuide(headersDataTable, data, checkbox)}
                            </div>
                            <div className="form-inline justify-content-end">
                                <div className="form-group mb-2">
                                    <label htmlFor="colFormLabelSm" className="col col-form-label col-form-label-sm text-right" style={{ width: 195 }}>
                                        Registros por página:
                                    </label>
                                </div>
                                <div className="form-group mb-2">
                                    <select
                                        className="col col-form-label col-form-label-sm text-right"
                                        style={{ width: 80 }}
                                        id='changePaginateSelect'
                                        onChange={this.changePaging}>
                                        <option value='5'>5</option>
                                    </select>&nbsp;&nbsp;
                                </div>

                                <div className="form-group mb-2">
                                    <label htmlFor="colFormLabelSm" id="tableInfo"
                                        className="col-form-label col-form-label-sm">
                                    </label>
                                </div>

                                <button className="btn btn-link btn-sm " style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Primera" onClick={this.first}><i
                                        className="fas fa-chevron-left btn-first"></i></button>
                                <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Anterior" onClick={this.previous}><i
                                        className="fas fa-chevron-left"></i></button>

                                <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Siguiente" onClick={this.next}><i
                                        className="fas fa-chevron-right"></i></button>
                                <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Última" onClick={this.last}><i
                                        className="fas fa-chevron-right btn-last"></i></button>


                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-dismiss="modal"
                                onClick={hideModal}
                            >
                                Cerrar
                            </button>
                            {forceProcess && view != 'invoiceAuthorization' &&

                                <button
                                    type="button"
                                    className="btn botonCorrect text-black"
                                    data-dismiss="modal"
                                    onClick={continueCreate}
                                >
                                    Crear
                                </button>
                            }
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default SunatGuideModal;
